<template>
  <v-card v-show="false">
    <v-card-title style="font-size: 1.4em">
      {{ sample_data.properties.dataset_title }}
    </v-card-title>
    <v-divider></v-divider>
    <v-card-text>
      <h4>Location:</h4>
      <p>
        {{
          sample_data.properties.location +
          (sample_data.properties.location2 ? ", " + sample_data.properties.location2 : "")
        }}
      </p>
      <h4>Author(s):</h4>
      <p>{{ sample_data.properties.investigators }}</p>
      <h4>Archive Type:</h4>
      <p>
        <v-chip>{{ sample_data.properties.archiveType }}</v-chip>
      </p>
    </v-card-text>
    <v-card-actions>
      <v-btn-toggle>
        <v-btn class="opendialog">Details</v-btn><v-spacer></v-spacer>
        <v-btn v-if="!selected" class="selectmap" color="success"
          >Add to Selection</v-btn
        >
        <v-btn v-if="selected" class="selectmap" color="error">Discard</v-btn>
      </v-btn-toggle>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  name: "CustomPopup",
  props: ["feature", "selected"],
  data: function () {
    return {
      sample_data: this.feature,
    };
  },
};
</script>

<style>
</style>